var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99992 6.66659C4.55789 6.66659 4.13397 6.49099 3.82141 6.17843C3.50885 5.86587 3.33325 5.44195 3.33325 4.99992C3.33325 4.55789 3.50885 4.13397 3.82141 3.82141C4.13397 3.50885 4.55789 3.33325 4.99992 3.33325C5.44195 3.33325 5.86587 3.50885 6.17843 3.82141C6.49099 4.13397 6.66659 4.55789 6.66659 4.99992C6.66659 5.21879 6.62348 5.43552 6.53972 5.63772C6.45596 5.83993 6.33319 6.02367 6.17843 6.17843C6.02367 6.33319 5.83993 6.45596 5.63772 6.53972C5.43552 6.62348 5.21879 6.66659 4.99992 6.66659ZM4.99992 0.333252C3.76224 0.333252 2.57526 0.824917 1.70009 1.70009C0.824917 2.57526 0.333252 3.76224 0.333252 4.99992C0.333252 8.49992 4.99992 13.6666 4.99992 13.6666C4.99992 13.6666 9.66659 8.49992 9.66659 4.99992C9.66659 3.76224 9.17492 2.57526 8.29975 1.70009C7.42458 0.824917 6.2376 0.333252 4.99992 0.333252Z",
    fill: "#2c3b70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ab9e344b.svg";
export { ForwardRef as ReactComponent };